import { Injectable } from '@angular/core';

/*
  Generated class for the LayoutsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LayoutsProvider {
  layouts: any = null;
  categories: any = ["crop","phones","tablets","desktops","watchs","icons"];

  constructor() {
    // console.log('Hello LayoutsProvider Provider');
  }

  getCategories(){
    // console.log("getCategories",this.categories);
    return this.categories;
  }

  getLayouts(){
    if(this.layouts == null){
      this.layouts = [];
      this.initLayouts();
    }

    // console.log("getLayouts",this.layouts);
    return this.layouts;
  }
  getLayout(type, index){
    // console.log("getLayout(" + type+ ")", index);
    if(this.layouts == null){
      this.layouts = [];
      this.initLayouts();
    }
    // console.log("this.layouts",this.layouts);
    return this.layouts[type][index];
  }


  initLayouts(){
    this.initCrop();
    this.initPhones();
    this.initTablets();
    this.initDesktops();
    this.initWatchs();
    this.initIcons();
  }

  initCrop(){
    this.layouts["crop"]=[];
    this.layouts["crop"].push({
      type:"crop",
      title: "Clear",
      name: "centered",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:15,
        right:0.3,
        bottom:0.15,
        left:0.3,
        vertical:0,
        horizontal:0
      }
    });
  }

  initPhones(){
    this.layouts["phones"]=[];
    this.layouts["phones"].push({
      type:"phones",
      title: "Centered",
      name: "centered",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:0.15,
        right:0.3,
        bottom:0.15,
        left:0.3,
        vertical:0,
        horizontal:0
      }
    });


    this.layouts["phones"].push({
      type:"phones",
      title: "Fullscreen",
      name: "fullscreen",
      rotate: 0,
      radius: 0,
      zoom : 18,
      margin: {
        top:0.05,
        right:0.25,
        bottom:0.05,
        left:0.25,
        vertical:0,
        horizontal:0
      }
    });


    this.layouts["phones"].push({
      type:"phones",
      title: "Bottom",
      name: "bottom",
      rotate: 0,
      radius: 0,
      zoom : 0.3,
      margin: {
        top:0.2,
        right:0.25,
        bottom:0,
        left:0.25,
        vertical:1.1,
        horizontal:0
      }
    });
    this.layouts["phones"].push({
      type:"phones",
      title: "Top",
      name: "top",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:0,
        right:0.25,
        bottom:0.2,
        left:0.25,
        vertical:0.9,
        horizontal:0
      }
    });



    this.layouts["phones"].push({
      type:"phones",
      title: "Left",
      name: "left",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:0.1,
        right:0.4,
        bottom:0.1,
        left:0.1,
        vertical:0,
        horizontal:-40
      }
    });

    this.layouts["phones"].push({
      type:"phones",
      title: "Right",
      name: "right",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:0.1,
        right:0.1,
        bottom:0.1,
        left:0.4,
        vertical:0,
        horizontal:40
      }
    });

    this.layouts["phones"].push({
      type:"phones",
      title: "Rotate Left",
      name: "rotateleft",
      rotate: -20,
      radius: 0,
      zoom : 30,
      margin: {
        top:0.1,
        right:0.25,
        bottom:0.1,
        left:0.25,
        vertical:30,
        horizontal:-30
      }
    });

    this.layouts["phones"].push({
      type:"phones",
      title: "Rotate Right",
      name: "rotateright",
      rotate: 20,
      radius: 0,
      zoom : 30,
      margin: {
        top:0.1,
        right:0.25,
        bottom:0.1,
        left:0.25,
        vertical:-30,
        horizontal:-70
      }
    });

    this.layouts["phones"].push({
      type:"phones",
      title: "Zoom Top",
      name: "zoomtop",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:0.3,
        right:0.25,
        bottom:-0.3,
        left:0.25,
        vertical:50,
        horizontal:0
      }
    });
    this.layouts["phones"].push({
      type:"phones",
      title: "Zoom Bottom",
      name: "zoombottom",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:-0.3,
        right:0.25,
        bottom:0.3,
        left:0.25,
        vertical:-50,
        horizontal:0
      }
    });


  }

  initTablets(){
    this.layouts["tablets"]=[];
    this.layouts["tablets"].push({
      type:"tablets",
      title: "Normal",
      name: "normal",
      rotate: 0,
      radius: 0,
      zoom :  30,
      margin: {
        top:0.1,
        right:0.2,
        bottom:0.1,
        left:0.2,
        vertical:0,
        horizontal:0
      }
    });
    this.layouts["tablets"].push({
      type:"tablets",
      title: "Landscape",
      name: "landscape",
      rotate: 0,
      radius: 0,
      zoom : 40,
      margin: {
        top:0.2,
        right:0.1,
        bottom:0.2,
        left:0.1,
        vertical:0,
        horizontal:0
      }
    });
  }


  initDesktops(){
    this.layouts["desktops"]=[];
    this.layouts["desktops"].push({
      type: "desktops",
      title: "Zoomed",
      name: "zoomed",
      rotate: 0,
      radius: 0,
      zoom : 41,
      margin: {
        top:0.2,
        right:0.1,
        bottom:0.2,
        left:0.1,
        vertical:0,
        horizontal:0
      }
    });

    this.layouts["desktops"].push({
      type: "desktops",
      title: "Centered",
      name: "centered",
      rotate: 0,
      radius: 0,
      zoom : 0.5,
      margin: {
        top:0.3,
        right:0.2,
        bottom:0.3,
        left:0.2,
        vertical:0,
        horizontal:0
      }
    });

    this.layouts["desktops"].push({
      type: "desktops",
      title: "Bottom",
      name: "Bottom",
      rotate: 0,
      radius: 0,
      zoom : 30,
      margin: {
        top:0.40,
        right:0.05,
        bottom:0,
        left:0.05,
        vertical:31,
        horizontal:0
      }
    });
  }

  initWatchs(){
    this.layouts["watchs"]=[];
    this.layouts["watchs"].push({
      type: "watchs",
      title: "Watch centered",
      name: "watch_centered",
      rotate: 0,
      radius: 0,
      zoom : 18,
      margin: {
        top:0.15,
        right:0.15,
        bottom:0.15,
        left:0.15,
        vertical:0,
        horizontal:0
      }
    });

    this.layouts["watchs"].push({
      type:"watchs",
      title: "Fullscreen",
      name: "fullscreen",
      rotate: 0,
      radius: 0,
      zoom : 10,
      margin: {
        top:0.05,
        right:0.05,
        bottom:0.05,
        left:0.05,
        vertical:0,
        horizontal:0
      }
    });
  }

    initIcons(){
      this.layouts["icons"]=[];
      this.layouts["icons"].push({
        type: "icons",
        title: "App Store Icon",
        name: "app_store_icon",
        rotate: 0,
        radius: 0.3,
        zoom : 18,
        margin: {
          top:0.15,
          right:0.15,
          bottom:0.15,
          left:0.15,
          vertical:0,
          horizontal:0
        }
      });
    }

}



// WEBPACK FOOTER //
// ./src/providers/layouts/layouts.ts